/**
 * @generated SignedSource<<b887436db1313e1fc44f91d347b0ea7c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Header_spreadsheetViewResult$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueTableGroupByDropdown_GroupByDropdown">;
  readonly " $fragmentType": "main_issueNavigator_Header_spreadsheetViewResult";
};
export type main_issueNavigator_Header_spreadsheetViewResult$key = {
  readonly " $data"?: main_issueNavigator_Header_spreadsheetViewResult$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Header_spreadsheetViewResult">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Header_spreadsheetViewResult",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
    }
  ],
  "type": "JiraSpreadsheetView",
  "abstractKey": "__isJiraSpreadsheetView"
};

(node as any).hash = "9209de4f52715ede5d9374cb200a94ff";

export default node;
